import React, { useState } from "react";
import "./ApplyForm.css";
import FormBanner from "./FormBanner";
import TheForm from "./TheForm";
import FirstStepSection from "../FirstStepSection";

export default function ApplyForm() {
  const [data, setData] = useState({
    name: "", phone: "", email: "",
    specialty: "", license: "", city: "",
    experience: "", bio: "", cv: null, agree: false,
  });

  const update = (e) => {
    const { name, value, type, checked, files } = e.target;
    setData((d) => ({
      ...d,
      [name]: type === "checkbox" ? checked : (type === "file" ? files[0] : value)
    }));
  };

  const submit = (e) => {
    e.preventDefault();
    console.log("Apply payload:", data);
    alert("تم إرسال طلبك بنجاح 👌");
  };

  return (
    <section className="apply" dir="rtl" aria-labelledby="apply-title">
      <FormBanner />
      <TheForm/>
      <FirstStepSection />
     
    </section>
  );
}
